import request from '@/utils/request'
import qs from 'qs'
export function loadNearPoint(ll) {
  return request({
    url: "/api/getNearPoints",
    method: 'post',
    data: ll
  })
}

export function getCompanyList(params) {
  return request({
    url: "/api/xcCompanyInfo"+ "?" + qs.stringify(params, { indices: false }),
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/companyInfo.js